<script setup lang="ts">
import FormTipoEvento from '../components/form-tipoevento.vue'
import { useTipoEventoStore } from '../store/useTipoEventoStore'

definePage({
  meta: {
    navActiveLink: 'admin-tipo-evento',
    action: 'create',
    subject: 'tipo-evento',
  },
})

const { resetForm } = useTipoEventoStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormTipoEvento />
</template>
